import React, { Component } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import { Formik } from "formik";
import { getPendingReceivePoItems } from "../../../../../services/inventory/procurementService";
import { getPendingReceivedItemsTransferDetail } from "../../../../../services/inventory/itemsMovement";
import {
  FormDateField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { saveItemsReceived } from "../../../../../services/inventory/itemsMovement";
import { Editor } from "primereact/editor";
import { Card, Badge } from "react-bootstrap";
import { DialogActions } from "@material-ui/core";
import { Alert } from "react-bootstrap";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import {
  onPreventEnterSubmitting,
  setObject,
} from "../../../../../utils/utils";
import ReceiveItem from "./receiveItem";
import { formatDate } from "../../../../../utils/utils";
import withGlobalData from "../../../common/withGlobalData";
import store from "../../../../../store/store";
import { DateTime } from "luxon";
import ItemsCondition from "./ItemsCondition";
const itemReceiveFormSchema = yup.object().shape({
  moveDate: yup.date("Receiving Date is required"),
  vendorDeliveryID: yup
    .string()
    .label("Vendor Delivery ID")
    .max(50),
  itemList: yup.array().of(
    yup.object().shape({
      receive: yup.boolean(),
      warehouseID: yup.number(),
      itemID: yup.number(),
      varCode: yup.string(),
      qtyRemaining: yup.number().min(0),
      qtyReceived: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value))
        .nullable()
        //.required("Quantity is required")
        //.moreThan(0, "Quantity cannot be zero or empty")
        .max(
          yup.ref("qtyRemaining"),
          "Received Quantity cannot be more than remaining Quantity"
        )
        .default(0),
      uomID: yup.number(),
      uomName: yup.string().required("Unit is required"),
      productionDate: yup
        .date()
        .nullable()
        .max(
          yup.ref("expiryDate"),
          "Production Date must be less equal to Expiry Date"
        ),
      expiryDate: yup
        .date()
        .nullable()
        .min(
          yup.ref("productionDate"),
          "Expiry Date must be greater equal to Production Date"
        ),
      batchSplitList: yup.array().of(
        yup.object().shape({
          qtyReceived: yup
            .number()
            .transform((value) => (isNaN(value) ? 0 : value))
            .nullable()
            .required("Quantity is required")
            .moreThan(0, "Quantity cannot be zero or empty")
            .default(0),
        })
      ),
    })
  ),
});

class ItemsReceiveForm extends Component {
  state = {
    message: { visible: false, type: "success", message: "" },
    itemReceive: {
      purchaseOrderID: 0,
      purchaseOrderCode: "",
      vendorName: "",
      purchaseDate: DateTime.now().startOf("day"),
      expDeliveryDate: DateTime.now().endOf("day"),
      grStatus: 1,
      grStatusDesc: "",
      fromLocation: "",
      fromLocationType: "",
      toLocation: "",
      toLocationType: "",
      transferID: 0,
      warehouseID: 0,
      outletID: 0,
      moveDate: DateTime.now().startOf("day"),
      note: "",
      vendorDeliveryID: "",
      itemList: [],
      itemsCondition: [],
    },
    activeIndex: 0,
    activeIndex2: 0,
  };

  componentDidMount() {
    const { po, transferID = 0 } = this.props;
    const { globalData } = this.props;
    const { auth } = store.getState();

    let appCode = "";
    let objectID = 0;
    if (po.ID > 0) {
      appCode = "PORD";
      objectID = po.ID;
    } else if (transferID > 0) {
      appCode = "TRNIT";
      objectID = transferID;
    }

    setObject(globalData.socket, "lock", objectID, appCode, auth.user).then(
      (response) => {
        this.getPendingReceivedItems();
      }
    );
  }

  componentWillUnmount() {
    const { po, transferID = 0 } = this.props;
    const { globalData } = this.props;
    const { auth } = store.getState();

    let appCode = "";
    let objectID = 0;
    if (po.ID > 0) {
      appCode = "PORD";
      objectID = po.ID;
    } else if (transferID > 0) {
      appCode = "TRNIT";
      objectID = transferID;
    }
    setObject(globalData.socket, "release", objectID, appCode, auth.user);
  }

  async getPendingReceivedItems() {
    const {
      po,
      transfer,
      transferID = 0,
      warehouseID = 0,
      outletID = 0,
    } = this.props;
    const { itemReceive } = this.state;
    let itemList = [];
    const itemsCondition = [];
    if (po.ID > 0) {
      const response = await getPendingReceivePoItems(po.ID, "ALL");
      const { data } = response.data;
      const itemListData = data.poItemsReturn;
      if (itemListData && itemListData.length > 0) {
        itemListData.forEach((item, index) => {
          const variantValue = [];

          for (const itemVariant of item.item.batchVariant) {
            variantValue.push({
              batchVariantID: itemVariant.ID,
              varName: itemVariant.varName,
              dataType: itemVariant.dataType,
              stringValue: "",
              dateValue: DateTime.now(),
              numberValue: 0,
            });
          }
          itemList.push({
            ID: item.ID,
            purchaseOrderItemID: item.ID,
            itemsTransferID: 0,
            twarehouseID: parseInt(warehouseID),
            itemID: item.itemID,
            itemType: item.itemType,
            itemTypeName: item.itemTypeName,
            itemCode: item.itemCode,
            itemName: item.itemName,
            varCode: item.varCode,
            batchID: 0,
            batchCode: "",
            qtyReceived: 0,
            qtyRemaining: item.qty,
            uomID: item.uomID,
            uomName: item.uomName,
            productionDate: null,
            expiryDate: null,
            purchaseRequests: item.purchaseRequests,
            batchSplitList: [],
            splitInd: false,
            //itemType: item.item.itemType,
            batchVariantValue: variantValue,
            batchVariantValueIn: variantValue,
          });

          itemsCondition.push({
            ID: 0,
            purchaseOrderID: item.purchaseOrderID,
            purchaseOrderItemID: item.ID,
            itemMovementID: 0,
            vendorID: 0,
            receivedWarehouseID: warehouseID,
            conditionType: 1,
            itemID: item.itemID,
            itemType: item.itemType,
            itemTypeName: item.itemTypeName,
            varCode: item.varCode,
            itemCode: item.itemCode,
            itemName: item.itemName,
            qty: 0,
            uomID: item.uomID,
            uomName: item.uomName,
            note: "",
            splitInd: false,
            itemsConditionSplit: [],
          });
        });
      }
      itemReceive.vendorName = po.vendor.vendorName;
      itemReceive.purchaseDate = formatDate(po.purchaseDate);
      itemReceive.expDeliveryDate = formatDate(po.expDeliveryDate);
      itemReceive.purchaseOrderID = po.ID;
      itemReceive.purchaseOrderCode = po.purchaseOrderCode;
      itemReceive.grStatus = po.grStatus;
      itemReceive.grStatusDesc = po.grStatusDesc;
      itemReceive.itemsCondition = itemsCondition;
    } else if (transferID > 0) {
      const response = await getPendingReceivedItemsTransferDetail(transferID);
      const { data } = response.data;
      const itemListData = data.itemsTransfer;
      if (itemListData && itemListData.length > 0) {
        itemListData.forEach((item) => {
          itemList.push({
            ID: item.ID,
            purchaseOrderItemID: 0,
            itemsTransferID: item.ID,
            twarehouseID: parseInt(warehouseID),
            toutletID: outletID,
            itemID: item.itemID,
            itemType: item.itemType,
            itemTypeName: item.itemTypeName,
            itemCode: item.itemCode,
            itemName: item.itemName,
            varCode: item.varCode,
            batchID: item.batchID,
            batchCode: item.batchCode,
            qtyReceived: item.qty,
            qtyRemaining: item.qty,
            uomID: item.uomID,
            uomName: item.uom.uomName,
            splitInd: false,
          });
        });
      }
      itemReceive.grStatus = transfer.grStatus;
      itemReceive.grStatusDesc = transfer.grStatusDesc;
      itemReceive.fromLocation = transfer.fromLocation;
      itemReceive.fromLocationType = transfer.fromLocationType;
      itemReceive.toLocation = transfer.toLocation;
      itemReceive.toLocationType = transfer.toLocationType;
      itemReceive.note = transfer.note;
    }
    itemReceive.transferID = transferID;
    itemReceive.warehouseID = parseInt(warehouseID);
    itemReceive.outletID = outletID;
    itemReceive.itemList = itemList;
    this.setState({ itemReceive });
  }

  render() {
    const { message, itemReceive } = this.state;
    const { po, transferID, warehouseID, onSubmitReceivedItem } = this.props;
    return (
      <React.Fragment>
        {message.visible ? (
          <Alert
            variant={message.type}
            onClose={() => {
              let messageSet = {
                visible: false,
                type: "success",
                message: "",
              };
              this.setState({ message: messageSet });
            }}
            dismissible
          >
            {message.message}
          </Alert>
        ) : null}
        <Formik
          initialValues={itemReceive}
          enableReinitialize={true}
          validateOnChange={false}
          validationSchema={itemReceiveFormSchema}
          onSubmit={async (values, { setStatus, setSubmitting }) => {
            let messageSet = {
              visible: false,
              type: "success",
              message: "",
            };
            let errorType = 0;
            let totalQtyReceived = 0;
            let itemCode = "";
            let itemName = "";
            let itemID = 0;
            let itemReceive = { ...values };
            itemReceive.outletID = parseInt(itemReceive.outletID);
            for (const item of itemReceive.itemList) {
              item.qtyReceived = parseFloat(item.qtyReceived);
              if (item.qtyReceived > 0) {
                errorType = 0;
                totalQtyReceived = item.qtyReceived;
                if (item.batchSplitList && item.batchSplitList.length > 0) {
                  for (const itemReceiveBatch of item.batchSplitList) {
                    totalQtyReceived += parseFloat(
                      itemReceiveBatch.qtyReceived
                    );
                  }
                }
                if (totalQtyReceived > parseFloat(item.qtyRemaining)) {
                  errorType = 1;
                  itemCode = item.itemCode;
                  itemName = item.itemName;
                  break;
                }
              }
            }

            for (const item of itemReceive.itemsCondition) {
              item.qty = parseFloat(item.qty);
              item.receivedWarehouseID = parseFloat(item.receivedWarehouseID);

              for (const itemSplit of item.itemsConditionSplit) {
                itemSplit.qty = parseFloat(itemSplit.qty);
                itemSplit.receivedWarehouseID = parseFloat(
                  itemSplit.receivedWarehouseID
                );
              }
            }
            if (totalQtyReceived === 0) {
              errorType = 2;
            }
            if (errorType === 0) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              })
                .fire({
                  title: "Are you sure want to save this Goods Received ?",
                  text: "Please note that you are responsible for this action",
                  icon: "question",
                  showCloseButton: true,
                  showCancelButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
                  cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                  reverseButtons: true,
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    saveItemsReceived(itemReceive).then((response) => {
                      Swal.mixin({
                        customClass: {
                          confirmButton:
                            "btn btn-success btn-md btn-pill btn-bold",
                        },
                        buttonsStyling: false,
                      }).fire({
                        title: "Saved",
                        html: response.data.message,
                        icon: "success",
                        showCloseButton: true,
                        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                      });
                      onSubmitReceivedItem();
                    });
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.mixin({
                      customClass: {
                        confirmButton:
                          "btn btn-success btn-md btn-pill btn-bold",
                      },
                      buttonsStyling: false,
                    }).fire({
                      title: "Cancelled",
                      text: "No change has been made",
                      icon: "info",
                      showCloseButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                    });
                  }
                });
            } else {
              if (errorType === 1) {
                messageSet.visible = true;
                messageSet.type = "danger";
                messageSet.message =
                  "Item ID " +
                  itemID +
                  " " +
                  itemName +
                  "Total Received is more than Quantity Remaining";
              } else if (errorType === 2) {
                messageSet.visible = true;
                messageSet.type = "danger";
                messageSet.message =
                  "All items receiving qty cannot be zero or empty";
              } else if (errorType === 3) {
                messageSet.visible = true;
                messageSet.type = "danger";
                messageSet.message =
                  "All Quantity Received Items of " +
                  itemName +
                  " must be Reserved";
              }

              this.setState({ message: messageSet });
              setSubmitting(false);
            }
          }}
        >
          {({
            values,
            status,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldError,
            setFieldTouched,
            isSubmitting,
          }) => (
            <form
              noValidate={true}
              autoComplete="off"
              className="kt-form"
              onSubmit={handleSubmit}
              onKeyDown={onPreventEnterSubmitting}
            >
              <div className="tabview mb-3">
                <div className="card">
                  <TabView className="tabview" scrollable>
                    <TabPanel
                      header="Goods Received Main"
                      rightIcon="fas fa-th-large"
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <Card>
                            <Card.Header>
                              <i className="fas fa-window-maximize"></i>
                              <span>
                                <strong>Goods Received Header</strong>
                              </span>
                              <Badge
                                className="float-right ml-1"
                                variant={
                                  values.grStatus === 1
                                    ? "danger"
                                    : values.grStatus === 2
                                    ? "warning"
                                    : values.grStatus === 3
                                    ? "success"
                                    : null
                                }
                              >
                                {values.grStatus !== 0
                                  ? "Goods " + values.grStatusDesc
                                  : null}
                              </Badge>
                            </Card.Header>
                            <Card.Body>
                              <div className="row">
                                <div className="col-sm-6 col-md-6 col-lg-6">
                                  {po && po.ID > 0 ? (
                                    <React.Fragment>
                                      <FormTextField
                                        label="Purchase Order ID"
                                        name="purchaseOrderCode"
                                        readonly
                                      />
                                      <FormTextField
                                        label="Vendor Name"
                                        name="vendorName"
                                        readonly
                                      />
                                      <FormTextField
                                        label="Vendor Delivery ID"
                                        name="vendorDeliveryID"
                                      />
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment>
                                      <FormTextField
                                        label="Transfer ID"
                                        name="transferID"
                                        readonly
                                      />
                                      <FormTextField
                                        label="Source Type"
                                        name="fromLocationType"
                                        readonly
                                      />
                                    </React.Fragment>
                                  )}
                                </div>
                                <div className="col-sm-6 col-md-6 col-lg-6">
                                  {po && po.ID > 0 ? (
                                    <React.Fragment>
                                      <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-6">
                                          <FormDateField
                                            label="Purchase Date"
                                            name="purchaseDate"
                                            readonly
                                          />
                                        </div>
                                        <div className="col-sm-12 col-md-12 col-lg-6">
                                          <FormDateField
                                            label="Expected Delivery Date"
                                            name="expDeliveryDate"
                                            readonly
                                          />
                                        </div>
                                      </div>
                                      <FormDateField
                                        label="Received Date"
                                        name="moveDate"
                                      />
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment>
                                      <FormDateField
                                        label="Received Date"
                                        name="moveDate"
                                      />
                                      <FormTextField
                                        label="Source Location"
                                        name="fromLocation"
                                        readonly
                                      />
                                    </React.Fragment>
                                  )}
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel header={"Note"} rightIcon="fas fa-sticky-note">
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <Editor
                            style={{ height: "200px", width: "100%" }}
                            onTextChange={(e) => {
                              setFieldValue("note", e.htmlValue);
                            }}
                            value={values.note}
                            placeholder="Type your notes here..."
                          />
                        </div>
                      </div>
                    </TabPanel>
                  </TabView>
                </div>
              </div>
              <div className="accordion mb-3">
                <div className="card">
                  <Accordion
                    className="accordion"
                    activeIndex={this.state.activeIndex}
                    onTabChange={(e) => this.setState({ activeIndex: e.index })}
                  >
                    <AccordionTab
                      header={
                        <React.Fragment>
                          <i className="fas fa-sitemap"></i>
                          <span>
                            <strong>Goods Received Items</strong>
                          </span>
                        </React.Fragment>
                      }
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <ReceiveItem
                            values={values}
                            transferID={transferID}
                            poID={po.ID}
                            warehouseID={warehouseID}
                            touched={touched}
                            errors={errors}
                            setFieldValue={setFieldValue}
                            setFieldError={setFieldError}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>
              </div>
              <div className="accordion">
                <div className="card">
                  <Accordion
                    className="accordion"
                    activeIndex={this.state.activeIndex2}
                    onTabChange={(e) =>
                      this.setState({ activeIndex2: e.index })
                    }
                  >
                    <AccordionTab
                      header={
                        <React.Fragment>
                          <i className="fas fa-sitemap"></i>
                          <span>
                            <strong>Items Condition</strong>
                          </span>
                        </React.Fragment>
                      }
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <ItemsCondition />
                        </div>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>
              </div>
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={this.props.onCloseItemsReceive}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-success btn-md btn-pill btn-bold"
                >
                  <i className="fas fa-save"></i>
                  Save
                </button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

export default withGlobalData(ItemsReceiveForm);
